/**
 * Accounting systems we support
 */
export var ACCOUNTING_SYSTEMS;
(function (ACCOUNTING_SYSTEMS) {
    ACCOUNTING_SYSTEMS["XERO"] = "XERO";
    ACCOUNTING_SYSTEMS["QBO"] = "QBO";
})(ACCOUNTING_SYSTEMS || (ACCOUNTING_SYSTEMS = {}));
/**
 * Accounting system specific terms and UI configurations
 */
export var ACCOUNTING_CONFIG;
(function (ACCOUNTING_CONFIG) {
    ACCOUNTING_CONFIG["HIDE_CONTACT_GROUPS"] = "HIDE_CONTACT_GROUPS";
    ACCOUNTING_CONFIG["HIDE_INVOICE_STATUS"] = "HIDE_INVOICE_STATUS";
    ACCOUNTING_CONFIG["HIDE_INVOICE_BRANDING"] = "HIDE_INVOICE_BRANDING";
    ACCOUNTING_CONFIG["REQUIRE_TAX_RATE"] = "REQUIRE_TAX_RATE";
    ACCOUNTING_CONFIG["DEFAULT_TAX_RATE"] = "DEFAULT_TAX_RATE";
})(ACCOUNTING_CONFIG || (ACCOUNTING_CONFIG = {}));
export const accountingSystemConfig = {
    'QBO': {
        settings: {
            [ACCOUNTING_CONFIG.HIDE_CONTACT_GROUPS]: true,
            [ACCOUNTING_CONFIG.HIDE_INVOICE_STATUS]: true,
            [ACCOUNTING_CONFIG.HIDE_INVOICE_BRANDING]: true,
            [ACCOUNTING_CONFIG.REQUIRE_TAX_RATE]: false,
            [ACCOUNTING_CONFIG.DEFAULT_TAX_RATE]: {
                label: `Item Default Rate`,
                value: null,
            },
        },
        terminology: {
            'Fee Income Account': 'Fee item',
            'Discount Account': 'Discount item',
            'contact': 'customer',
            'Contact': 'Customer',
            'Contacts': 'Customers',
            'Add Contact or Group': 'Add Customer',
            [`Quotes`]: 'Estimates',
            [`Quote`]: 'Estimate',
        },
        tooltips: {},
    },
    'XERO': {
        settings: {
            [ACCOUNTING_CONFIG.HIDE_CONTACT_GROUPS]: false,
            [ACCOUNTING_CONFIG.HIDE_INVOICE_STATUS]: false,
            [ACCOUNTING_CONFIG.HIDE_INVOICE_BRANDING]: false,
            [ACCOUNTING_CONFIG.REQUIRE_TAX_RATE]: false,
            [ACCOUNTING_CONFIG.DEFAULT_TAX_RATE]: {
                label: `Account Default Rate`,
                value: null,
            },
        },
        terminology: {
            'Fee Income Account': 'Fee Income Account',
            'Discount Account': 'Discount Account',
            'contact': 'contact',
            'Contact': 'Contact',
            'Contacts': 'Contacts',
            'Add Contact or Group': 'Add Contact or Group',
            [`Quotes`]: 'Quotes',
            [`Quote`]: 'Quote',
        },
        tooltips: {
            [`tax_rate`]: `(Optional) If not selected, or default, then the default tax rate for your account will be used.`,
        },
    },
};
export function getAccountingSystemsConfigured(config) {
    return Object.values(ACCOUNTING_SYSTEMS).filter(system => {
        var _a;
        return ((_a = accountingSystemConfig[system]) === null || _a === void 0 ? void 0 : _a.settings[config]) || false;
    });
}
//# sourceMappingURL=accountingSystems.js.map